import { DropdownMenu, DropdownMenuItem } from '@/components/Elements';
import { useLogout } from '@/lib/auth';
import { MenuItem } from '@headlessui/react';
import {
  ArrowRightStartOnRectangleIcon,
  ArrowTopRightOnSquareIcon,
  Cog6ToothIcon,
  DocumentTextIcon,
} from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { User } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export const UserIconMenu = ({
  displayUsername,
}: {
  displayUsername?: string;
}) => {
  const { t } = useTranslation();
  const logout = useLogout();
  const [isPolicyMenuOpen, setIsPolicyMenuOpen] = useState(false);

  const onClickLogout = () => {
    logout.mutate({});
  };

  const togglePolicyMenu = () => {
    setIsPolicyMenuOpen(!isPolicyMenuOpen);
  };

  const policyLinks = [
    { label: t('利用規約'), href: t('terms-and-conditions-url') },
    { label: t('プライバシーポリシー'), href: t('privacy-policy-url') },
    { label: t('データポリシー'), href: t('data-policy-url') },
  ];

  return (
    <DropdownMenu
      trigger={
        <div className="grid size-9 place-items-center rounded-full bg-white">
          <User className="size-4" />
        </div>
      }
      className="z-50 w-max divide-y divide-gray-100 overflow-visible"
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          setIsPolicyMenuOpen(false);
        }
      }}
    >
      {displayUsername && (
        <span
          className="m-1 block truncate text-gray-500 [font-size:clamp(0.65rem,2vw,0.875rem)]"
          translate="no"
        >
          {displayUsername}
        </span>
      )}
      <DropdownMenuItem>
        <Link
          to="/settings/profile"
          className="group flex w-full items-center gap-2"
        >
          <Cog6ToothIcon className="size-4" />
          {t('Settings')}
        </Link>
      </DropdownMenuItem>
      <MenuItem>
        {({ focus }) => (
          <div
            className={clsx(
              'flex w-full cursor-pointer items-center gap-2 px-3 py-1.5 text-left focus:outline-none',
              isPolicyMenuOpen || focus ? 'bg-gray-100' : 'hover:bg-gray-100'
            )}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              togglePolicyMenu();
            }}
          >
            <DocumentTextIcon className="size-4" />
            <span>{t('規約 / ポリシー')}</span>
          </div>
        )}
      </MenuItem>
      {isPolicyMenuOpen && (
        <>
          {policyLinks.map(({ label, href }) => (
            <MenuItem key={label}>
              {({ focus }) => (
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={clsx(
                    'flex w-full items-center justify-between gap-2 px-3 py-1.5 text-xs',
                    focus ? 'bg-gray-100' : 'hover:bg-gray-100'
                  )}
                >
                  <span>{label}</span>
                  <ArrowTopRightOnSquareIcon className="size-3.5 text-gray-400" />
                </a>
              )}
            </MenuItem>
          ))}
        </>
      )}
      <DropdownMenuItem onClick={onClickLogout}>
        <ArrowRightStartOnRectangleIcon className="size-4" />
        {t('ログアウト')}
      </DropdownMenuItem>
    </DropdownMenu>
  );
};
